import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=505d0f40&"
import script from "./Matches.vue?vue&type=script&lang=js&"
export * from "./Matches.vue?vue&type=script&lang=js&"
import style0 from "./Matches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports